import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getOperatorsL, getActTypes, deleteActType, deleteOperator } from "../api";

const OperatorList1 = ({ id_c }) => {
    const { t } = useContext(LanguageContext);
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    const loadData = async () => {
        const result = await getOperatorsL(id_c);
        setData(result);
    };

    useEffect(() => {
        loadData();
    }, [id_c]);

    if (!data) return <p>{t("MList1")}</p>;


    /*
    const handleEdit = (id_activity) => {
      navigate(`/activity-types/${id_activity}/edit`);
    };
  */
    const handleDelete = async (id_operator) => {
        if (!window.confirm(t("¿Eliminar este registro?"))) return;
        await deleteOperator(id_c, id_operator);
        await loadData();
    };

    return (
        <div className="box1">
            <div className="box9">


                <button className="button7" onClick={() => navigate("/new_operator")}> {/*New Operator*/}


                    {t("operator4") /* clave de i18n p/ “Nuevo Operador” */}
                </button>

                <table className="table5">
                    <thead>
                        <tr>
                            <th>{t("operator1") /* ID Operator */}</th>
                            <th>{t("operator2") /* Name */}</th>
                            <th colSpan={2}>{t("actType6")}</th>
                        </tr>


                    </thead>
                    <tbody>
                        {(data.operators || []).map((act) => (
                            <tr key={act.id_operator}>
                                <td>{act.id_operator}</td>
                                <td>{act.name_oper || "-"}</td>


                                <td>
                                    <button
                                        className="button"
                                        onClick={() => navigate(`/edit_operator/${act.id_operator}`)}
                                    >
                                        {t("MList7") /* Editar */}
                                    </button>
                                </td>


                                <td>
                                    <button className="buttonDel" onClick={() => handleDelete(act.id_operator)} >
                                        {t("MList8")}
                                    </button>
                                </td>


                            </tr>
                        ))}
                        {(!data.operators || data.operators.length === 0) && (
                            <tr>
                                <td colSpan={4}>{t("Sin registros")}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default OperatorList1;
